/* Independent of Ella/jQuery; supports Shopify theme editor section reloads. */
(() => {
  function init(root = document) {
    root.querySelectorAll('[data-wcd-slider]').forEach(slider => {
      if (slider.dataset.ready) return;
      slider.dataset.ready = 'true';
      const slides = [...slider.querySelectorAll('[data-wcd-slide]')];
      let index = 0;
      const show = next => {
        if (!slides.length) return;
        index = (next + slides.length) % slides.length;
        slides.forEach((slide, i) => { slide.hidden = i !== index; });
        slider.querySelector('[data-wcd-count]').textContent = `${String(index + 1).padStart(2, '0')} / ${String(slides.length).padStart(2, '0')}`;
      };
      slider.querySelector('[data-wcd-prev]')?.addEventListener('click', () => show(index - 1));
      slider.querySelector('[data-wcd-next]')?.addEventListener('click', () => show(index + 1));
      slider.addEventListener('wcd:select', event => { const i = slides.indexOf(event.detail); if (i >= 0) show(i); });
      show(0);
    });
  }
  document.addEventListener('click', event => {
    const filter = event.target.closest('[data-wcd-filter]');
    if (filter) {
      const section = filter.closest('section');
      section.querySelectorAll('[data-wcd-filter]').forEach(button => button.setAttribute('aria-pressed', String(button === filter)));
      section.querySelectorAll('[data-wcd-category]').forEach(card => { card.hidden = filter.dataset.wcdFilter !== 'all' && card.dataset.wcdCategory !== filter.dataset.wcdFilter; });
    }
    const inquiry = event.target.closest('[data-wcd-inquire]');
    if (inquiry) {
      const value = inquiry.dataset.wcdInquire;
      const input = document.querySelector('[data-wcd-interest]');
      if (input) input.value = value;
      if (!input || new URL(inquiry.href, location.href).pathname !== location.pathname) { try { sessionStorage.setItem('wcd-inquiry', value); } catch (_) {} }
    }
    const menuLink = event.target.closest('.wcd-mobile-menu a');
    if (menuLink) menuLink.closest('details').open = false;
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:block:select', event => {
    const slide = event.target.closest('[data-wcd-slide]');
    if (slide) slide.closest('[data-wcd-slider]').dispatchEvent(new CustomEvent('wcd:select', { detail: slide }));
  });
  init();
  const input = document.querySelector('[data-wcd-interest]');
  if (input) { try { const saved = sessionStorage.getItem('wcd-inquiry'); if (saved) { input.value = saved; sessionStorage.removeItem('wcd-inquiry'); } } catch (_) {} }
})();
